export enum SnackbarType {
  Regular = 'Regular',
  Info = 'Info',
  Warning = 'Warning',
  Error = 'Error',
  Success = 'Success',
}

export type SnackbarMessage = {
  type: SnackbarType;
  message: string;
  actionData?: ActionData;
};

export type HandleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => void;

export type ActionData = {
  getHandler: (handleClose: HandleClose) => () => void;
  text: string;
};

export type ShowSnackbar = (type: SnackbarType, message: string, actionData?: ActionData) => void;
